import type { IContextMutationResult } from '@modules/core/services/query/types';
import type {
  IDownloadReportLinkResponse,
} from '@modules/download-report/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

import {
  DOWNLOAD_REPORT_DELETE_MUTATION_KEY,
  DOWNLOAD_REPORT_DELETE_URL,
  DOWNLOAD_REPORT_LIST_QUERY_KEY,
  DOWNLOAD_REPORT_PERMISSIONS,
} from '../constants';

export default function useDownloadReportDeleteMutation(): IContextMutationResult<
  IDownloadReportLinkResponse,
  Error,
  number
> {
  const { fetchDelete } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<IDownloadReportLinkResponse, Error, number>({
    mutationKey: [DOWNLOAD_REPORT_DELETE_MUTATION_KEY],
    mutationFn: (id) => fetchDelete<IDownloadReportLinkResponse>(
      DOWNLOAD_REPORT_DELETE_URL,
      {
        permission: DOWNLOAD_REPORT_PERMISSIONS.EDIT,
        urlParams: {
          id,
        },
      },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [DOWNLOAD_REPORT_LIST_QUERY_KEY] });

      displayPresetToast('removed');
    },
  });
}
